import { createSelector } from "reselect"
import { reducerInit } from "../../api/dbselect.js"

const init = reducerInit("service", "serviceorder")

export const serviceReducer = (state = init, action) => {
	switch (action.type) {
		case "INSERT_SERVICE":
			return [...state, action.response[0]]

		case "UPDATE_SERVICE": {
			const updatedState = state.map((object) => {
				if (object.serviceid === action.id) {
					return { ...object, ...action.json }
				}
				return object
			})
			return [...updatedState]
		}

		case "DELETE_SERVICE":
			return state.filter((object) => object.serviceid !== action.id)

		default:
			return state
	}
}

export const selectServicesWithOnlyIds = createSelector(
	(state) => state.serviceReducer,
	(services) => services.map((sObj) => sObj.serviceid)
)

export const selectServiceById = createSelector(
	(state, serviceId) => state.serviceReducer,
	(_, serviceId) => serviceId,
	(services, serviceId) => {
		const result = services.filter((service) => serviceId === service.serviceid)
		return result[0]
	}
)
